/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forgotpassword1Inputs */

const en_forgotpassword1 = /** @type {(inputs: Forgotpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgot password?`)
};

const de_forgotpassword1 = /** @type {(inputs: Forgotpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort vergessen?`)
};

/**
* | output |
* | --- |
* | "Forgot password?" |
*
* @param {Forgotpassword1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const forgotpassword1 = /** @type {((inputs?: Forgotpassword1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forgotpassword1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forgotpassword1(inputs)
	return de_forgotpassword1(inputs)
});
export { forgotpassword1 as "forgotPassword" }